import { defDatetimeRangeFilter } from "helpers/date";
import { paramsObject } from "helpers/system";
import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/userLogs";
import List from "./list";
import Show from "./show";

const UserLogs = (props) => {
    useEffect(() => {
        return () => props.resetPaginationPage("userlogs", defDatetimeRangeFilter("date"));
    }, []);

    const { match, location, history } = props;
    const rootUrl = `${match.path}/list`;
    const back = () => history.push(rootUrl);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    path={rootUrl}
                    render={() => (
                        <>
                            <List {...props} isTable transition="full" title="Логи запросов" nofilter />
                            <Route
                                path={`${rootUrl}/:id`}
                                render={(rest) => {
                                    const { id } = rest.match.params;
                                    const { date } = paramsObject(rest.location.search);
                                    return <Show {...rest} source={source} back={back} date={date} id={id} />;
                                }}
                            />
                        </>
                    )}
                />
            </Switch>
        </div>
    );
};

export default UserLogs;
